
import {
  TheIdentifier,
  TheCode,
  TheEmail,
  ThePassword,
  Welcome,
} from "../../../Common/CommonSteps";
import AppSvc from "../../../../services/app-svc";

let service = null;

export default {
  name: "the-selection",
  components: {
    TheIdentifier,
    TheCode,
    TheEmail,
    ThePassword,
    Welcome,
  },
  props: {
    isTpn: {
      type: Boolean,
      required: true,
    },
    tpnChainId: {
      type: Number,
      required: true,
    },
    tpnSiteId: {
      type: Number,
      required: true,
    },
    isProfile: {
      type: Boolean,
      default: false,
      required: false,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    layout: {
      required: false,
      type: String,
      default: "chain",
    },
    prefilledMobile: {
      required: false,
      type: String,
      default: "",
    },
    useAxios: Boolean,
  },
  data() {
    return {
      error: "",
      showResendText: false,
      inputHasFocus: false,
      addNewEmailProcessStarted: false,
      state: {
        ID: "check-user",
        CODE: "verify-sms",
        EMAILCODE: "verify-email",
        EMAIL: "enter-email",
        CREATEPASSWORD: "create-password",
        INSERTPASSWORD: "insert-password",
        WELCOME: "welcome-screen",
        RESETPASSWORD: "reset-password",
        RESETVERIFYCODE: "reset-verify-mobile",
        RESETVERIFYEMAIL: "reset-verify-email",

        RESET_EMAIL: "reset-email",
      },
      currentForm: "check-user",
      previousForm: "",
      username: "",
      code: "",
      email: "",
      password: "",
      clientIdentity: null,
      currentEmail: "",
      hasMounted: false
    };
  },
  computed: {
    loggingInWithEmail() {
      const emailRegexValidation =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegexValidation.test(this.username);
    },
    origin(){
      return localStorage.getItem('origin') ?? ''
    }
  },
  methods: {
    verifyInputFields() {
      switch (this.currentForm) {
        case "check-user":
          return this.username === "";
        case "enter-email":
          return (
            this.email === "" ||
            (this.currentEmail === this.email && this.addNewEmailProcessStarted)
          );
        case "create-password":
          return this.password === "";
        case "insert-password":
          return this.password === "";
        default:
          return false;
      }
    },
    resetError() {
      this.error = "";
    },
    setUsername(value) {
      this.error = "";
      this.username = value;
    },
    setCode(value) {
      this.code = value;
    },
    setEmail(value) {
      this.error = "";
      this.email = value;
    },
    setPassword(value) {
      this.error = "";
      this.password = value;
      this.$emit('setPassword', value)
    },
    changeView(state) {
      this.$emit("changeView", state);
    },
    close() {
      this.$emit("close");
    },
    VerifyStep(params = null) {
      var body = params ? params : {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        password: this.password
      };

      if (this.currentForm.includes("verify")) {
        const emailRegexValidation =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var isValidEmail = emailRegexValidation.test(this.email);
        var isValidUsername = emailRegexValidation.test(this.username);
        Object.assign(body, {
          clientIdentity: this.clientIdentity,
          code: this.code,
          email: isValidEmail
            ? this.email
            : isValidUsername
            ? this.username
            : "",
        });
      }
      if (this.currentForm === "enter-email") {
        Object.assign(body, {
          email: this.email,
        });
      }
      if (
        this.$route.query.action &&
        this.$route.query.siteId &&
        this.$route.query.customerId
      ) {
        Object.assign(body, {
          siteId: this.$route.query.siteId,
          customerId: this.$route.query.customerId,
        });
      }
      if (
        [
          this.state.CODE,
          this.state.EMAILCODE,
          this.state.RESETVERIFYCODE,
          this.state.RESETVERIFYEMAIL,
          this.state.ID,
          this.state.INSERTPASSWORD,
          this.state.RESETPASSWORD,
          this.state.CREATEPASSWORD,
        ].includes(this.currentForm) ||
        this.$refs.validation.validate()
      ) {
        service.VerifyLoginStep(this.apiUrl, body).then((response) => {
          this.error = "";
          if (response.data.responseCode === 200) {
            this.showResendText = false
            var result = response.data;
            this.email = result.fixitNoUser?.email
              ? result.fixitNoUser?.email
              : this.email;
            if (result.nextStep == this.state.EMAILCODE) {
              this.currentEmail = result.fixitNoUser?.email;
            }
            if (result.nextStep == this.state.RESETVERIFYEMAIL && result.fixitNoUser?.email) {
              this.username = result.fixitNoUser?.email;
            }
            this.clientIdentity = result.clientIdentity;
            this.previousForm = this.currentForm;
            this.currentForm = result.nextStep;
            if (result.nextStep === "update-userdata") {
              this.$emit("setUpdateData", result.fixitNoUser);
            }
            if (result.nextStep === "welcome-screen") {
              this.$emit("setUser", result.fixitNoUser);
            }
          } else {
            this.showResendText = false;
            this.error = response.data.responseMessage;
          }
        });
      }
    },
    resendCode() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        email: this.email,
        resendCode: 'true'
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        this.error = "";
        if (response.data.responseCode === 200) {
          this.showResendText = true;
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
        } else {
          this.error = response.data.responseMessage;
        }
      });
    },
    resetPassword() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.state["RESETPASSWORD"],
        email: this.email,
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        if (response.data.responseCode === 200) {
          var result = response.data;

          if (result.nextStep == this.state.RESETVERIFYEMAIL && result.fixitNoUser?.email) {
            this.username = result.fixitNoUser?.email;
          }
          
          this.clientIdentity = result.clientIdentity;
          this.currentForm = result.nextStep;
        }
      });
    },
    resetEmail() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.state["RESET_EMAIL"],
        email: this.email,
        password: this.password
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
          this.currentForm = result.nextStep;
          this.addNewEmailProcessStarted = true;
          this.showResendText = false
        } else {
          this.error = response.data.responseMessage;
        }
      });
    },
  },
  async mounted() {
    service = await AppSvc(this.useAxios ? this.$axios : null);
    if (this.prefilledMobile !== '') {
      this.setUsername(this.prefilledMobile)
      this.VerifyStep(
        {
          username: this.username,
          isTpn: this.isTpn.toString(),
          tpnChainId: this.tpnChainId.toString(),
          tpnSiteId: this.tpnSiteId.toString(),
          step: 'check-user',
        }
      )
    }
    this.hasMounted = true
  },
  watch: {
    currentForm(oldVal, newVal) {
      if (oldVal != newVal) {
        this.error = "";
      }
    },
  },
};
